import { ITEM_SLOT, ITEM_TYPE } from '@shared/constants/items.constant';

export const heroItemsBody: number[][] = [
  [ITEM_TYPE.HEAD],
  [ITEM_TYPE.BODY],
  [ITEM_TYPE.BOOTS],
  [ITEM_TYPE.GLOVES],
  [ITEM_TYPE.BELT],
  //------
  [ITEM_TYPE.ONE_HAND, ITEM_TYPE.TWO_HAND],
  [ITEM_TYPE.OFF_HAND],
  [ITEM_TYPE.RING],
  [ITEM_TYPE.RING * 10],
  [ITEM_TYPE.AMULET],
];

export const heroItemsSkills: number[][] = [[ITEM_SLOT.SKILL_1], [ITEM_SLOT.SKILL_2], [ITEM_SLOT.SKILL_3]];

export const heroItemsTypes: number[][] = [...heroItemsBody, ...heroItemsSkills];
